import React, { FunctionComponent } from 'react'
import { ReactSwitchProps } from 'react-switch'
import { Field, InputProps } from '../inputs'
import { LabelPosition } from 'view/styles/constants'
import styled from '@emotion/styled'
import { Toggle } from './Toggle'

interface LabeledToggleProps extends InputProps, Omit<ReactSwitchProps, 'onChange'> {
  leftLabel: string
  rightLabel: string
  label: string
  onUpdate: (value: boolean) => void
}

const LabeledTogglecontainer = styled.div`
  display: flex;
  margin-top: 3px;
`

const Label = styled.div`
  &:first-child {
    margin-right: 8px;
  }
  &:last-child {
    margin-left: 8px;
  }
`

export const LabeledToggle: FunctionComponent<LabeledToggleProps> = props => {
  const { leftLabel, rightLabel, ...rest } = props

  return (
    <LabeledTogglecontainer>
      <Label>{leftLabel}</Label>
      <Toggle {...rest} />
      <Label>{rightLabel}</Label>
    </LabeledTogglecontainer>
  )
}

export const LabeledToggleField = Field(LabeledToggle, { defaultLabelPosition: LabelPosition.Top })
